import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { SectionItem } from '../../models/menu.interfaces';

@Component({
  selector: 'idp-section-item',
  standalone: true,
  templateUrl: './section-item.component.html',
  styleUrls: ['./section-item.component.scss']
})
export class SectionItemComponent {
  @Input() item: SectionItem = {} as SectionItem;
  @Output() listItem: EventEmitter<Link> = new EventEmitter<Link>();
  @Input() indexValue = 0;
  @Input() lengthOfItem = 0;

  navigateTo(event: MouseEvent, link: Link) {
    event.preventDefault();
    this.listItem.emit(link);
  }
}
